import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AlertService} from "../services";
import {Subject} from "rxjs";
import {FormGroup} from "@angular/forms";
import {Page} from "../models/page";
import {DatatableComponent} from "@swimlane/ngx-datatable";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import {locale as polish} from "./i18n/pl";
import {first} from "rxjs/operators";
import {MatDialog} from "@angular/material/dialog";
import {FileList} from "../models/fileList";
import {InternalFileService} from "./service/internalFile.service";
import {File} from "../models/file";
import {DeleteFileDialogComponent} from "./dialog/deleteFileDialog.component";

@Component({
    templateUrl: './internalFile.component.html',
    styleUrls: ['./internalFile.component.scss',]
})


export class InternalFileComponent implements OnDestroy, OnInit {
    rows: any[];
    loadingIndicator: boolean;
    reorderable: boolean;
    deleteDialogRef: any;

    page = new Page();
    @ViewChild(DatatableComponent) table: DatatableComponent;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private fileService: InternalFileService,
        private alertService: AlertService,
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService,
        public _matDialog: MatDialog,
    ) {
        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;
        this.page.pageNumber = 0;
        this.page.size = 10;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.translationLoader.loadTranslations(polish);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Files');
    }

    ngOnInit() {
        this.setPage({offset: 0});
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    setPage(pageInfo) {
        this.loadingIndicator = true;
        this.rows = [];
        this.page.totalElements = 0;
        this.page.pageNumber = pageInfo.offset;

        if (typeof pageInfo.limit === "undefined") {
            pageInfo.limit = this.page.size;
        }


        this.fileService.getAll(pageInfo.offset * pageInfo.limit, pageInfo.limit).pipe(first())
            .subscribe((res: FileList) => {
                    this.rows = res.items;
                    this.loadingIndicator = false;
                    this.page.totalElements = res.total;
                    // this.page = pagedData.page;
                },
                error => {
                    this.alertService.error(error);
                })
    }

    showConfirmFileDeleteDialog(event: File) {
        this.deleteDialogRef = this._matDialog.open(DeleteFileDialogComponent, {
            panelClass: 'file-form-dialog',
            data      : {
                action : 'show',
                event: event,
            },
            width: '350px',
        });

        this.deleteDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.fileService.delete(event.id).pipe(first())
                    .subscribe(res => {
                        window.location.reload();
                    });

                this.deleteDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }
}
